import ChevronRightIcon from '@ordr-as/icons/ChevronRightIcon';
import { FC } from 'react';
import { ExpandedComponent } from './types';

interface Props {
  component: ExpandedComponent;
  subtitle?: string;
  isValid: boolean;
  onClick: () => void;
}

const ComponentListRow: FC<Props> = ({ component, subtitle, isValid, onClick }) => {
  const label = component.name;

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center justify-between border-b border-grey-lightest py-3 text-left"
    >
      <div className="flex flex-col">
        <span className={isValid ? 'text-base' : 'text-base text-orange-darkest'}>{label}</span>
        {subtitle && <span className="text-small text-grey-dark">{subtitle}</span>}
      </div>
      <ChevronRightIcon className="h-5 w-5 flex-shrink-0 text-grey-dark" />
    </button>
  );
};

export default ComponentListRow;
